import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ConsultaCategoriasOutput, ConsultaCoberturasOutput, ConsultaCompaniasOutput, ConsultaEstatusOutput, ConsultaMarcasOutput, ConsultaModelosOutput, ConsultaSubTiposOutput, ConsultaTercerosOutput, ConsultaTipoPersonaOutput, ConsultaTipoTerceroOutput, ConsultaVehiculosOutput, EliminaTerceroOutput, GuardaActualizaTerceroOutput } from '../../models/complementos-web/complementos-web-terceros.model';
import { ConsultaCategoriasInput, ConsultaCoberturasInput, ConsultaColoresInput, ConsultaColoresOutput, ConsultaCompaniasInput, ConsultaEstatusInput, ConsultaMarcasInput, ConsultaModelosInput, ConsultaSubTiposInput, ConsultaTercerosInput, ConsultaTipoPersonaInput, ConsultaTipoTerceroInput, ConsultaVehiculosInput, EliminaTerceroInput, GuardaActualizaTerceroInput } from '../../models/complementos-web/complementos-web-terceros.model';
import { ConsultaOficinasInput, ConsultaOperadoresInput, ConsultaFechasInput, ConsultaAjustadoresInput, ConsultaSiniestrosInput, ActualizaComplementoInput, ActualizaReglasAjusteInput, ActualizaServicioInput, ActualizaTerminoSiniestroInput, CancelarSubirArchivosExtenderInput, ConsultaCausasInput, ConsultaCoberturasXTipoySubtipoPagosInput, ConsultaComplementoGeneralInput, ConsultaConceptosXtendersInput, ConsultaContadoresInput, ConsultaConveniosInput, ConsultaDireccionInput, ConsultaEstadosInput, ConsultaEstatusAbogadoInput, ConsultaEstatusConceptoInput, ConsultaEstatusLesionadoInput, ConsultaEstimacionesInput, ConsultaEventoServicioInput, ConsultaFotografiasInput, ConsultaImporteSipacInput, ConsultaLesionadosGeneralInput, ConsultaLesionadosInput, ConsultaLesionadosServiciosInput, ConsultaMunicipiosInput, ConsultaPaisesInput, ConsultaProveedorInput, ConsultaRecuperacionesPagosInput, ConsultaRecuperacionesPagosReferenciasInput, ConsultaReglasAjusteInput, ConsultaResumenSiniestroInput, ConsultaServiciosGeneralInput, ConsultaServiciosInput, ConsultaSexoInput, ConsultaSinCostoInput, ConsultaSiniestroInput, ConsultaSubCausasInput, ConsultaSubTiposPagosInput, ConsultaSubTipoUbicacionesInput, ConsultaTipoEstimacionesInput, ConsultaTipoGruaInput, ConsultaTipoPaseInput, ConsultaTipoPerdidaInput, ConsultaTipoServiciosInput, ConsultaTipoSiniestroInput, ConsultaTiposPagosInput, ConsultaTiposRoboInput, ConsultaTipoUbicacionesInput, ConsultaTradicionalTipoInput, EliminaFotografiaInput, EliminaLesionadoInput, EliminaRecuperacionPagoInput, GeneraExpedienteElectronicoInput, GuardaActualizaLesionadoInput, GuardaActualizaObservacionesInput, GuardaActualizaRecuperacionPagoInput, GuardaEstimacionInput, GuardaFotografiasInput, LogOutInput, RegistraUsuarioPortalInput, ValidaCoberturasServicioTallerInput, VerificaTerminoSiniestroInput, ConsultaFechasOutput, ActualizaComplementoOutput, ActualizaReglasAjusteOutput, ActualizaServicioOutput, ActualizaTerminoSiniestroOutput, CancelarSubirArchivosExtenderOutput, ConsultaAjustadoresOutput, ConsultaCausasOutput, ConsultaCoberturasXTipoySubtipoPagosOutput, ConsultaComplementoGeneralOutput, ConsultaConceptosXtendersOutput, ConsultaContadoresOutput, ConsultaConveniosOutput, ConsultaDireccionOutput, ConsultaEstadosOutput, ConsultaEstatusAbogadoOutput, ConsultaEstatusConceptoOutput, ConsultaEstatusLesionadoOutput, ConsultaEstimacionesOutput, ConsultaEventoServicioOutput, ConsultaFotografiasOutput, ConsultaImporteSipacOutput, ConsultaLesionadosGeneralOutput, ConsultaLesionadosOutput, ConsultaLesionadosServiciosOutput, ConsultaMunicipiosOutput, ConsultaOficinasOutput, ConsultaOperadoresOutput, ConsultaPaisesOutput, ConsultaProveedorOutput, ConsultaRecuperacionesPagosOutput, ConsultaRecuperacionesPagosReferenciasOutput, ConsultaReglasAjusteOutput, ConsultaResumenSiniestroOutput, ConsultaServiciosGeneralOutput, ConsultaServiciosOutput, ConsultaSexoOutput, ConsultaSinCostoOutput, ConsultaSiniestroOutput, ConsultaSiniestrosOutput, ConsultaSubCausasOutput, ConsultaSubTiposPagosOutput, ConsultaSubTipoUbicacionesOutput, ConsultaTipoEstimacionesOutput, ConsultaTipoGruaOutput, ConsultaTipoPaseOutput, ConsultaTipoPerdidaOutput, ConsultaTipoServiciosOutput, ConsultaTipoSiniestroOutput, ConsultaTiposPagosOutput, ConsultaTiposRoboOutput, ConsultaTipoUbicacionesOutput, ConsultaTradicionalTipoOutput, EliminaFotografiaOutput, EliminaLesionadoOutput, EliminaRecuperacionPagoOutput, GeneraExpedienteElectronicoOutput, GuardaActualizaLesionadoOutput, GuardaActualizaObservacionesOutput, GuardaActualizaRecuperacionPagoOutput, GuardaEstimacionOutput, GuardaFotografiasOutput, LogOutOutput, RegistraUsuarioPortalOutput, ValidaCoberturasServicioTallerOutput, VerificaTerminoSiniestroOutput } from '../../models/complementos-web/complementos-web.model';
import { ResultApiResponse } from 'src/app/models/complementos-web/complementos-web-servicios.model';

@Injectable({
  providedIn: 'root'
})
export class ComplementoWebService {

  private readonly baseUrl = environment.wsUrl + 'api/SiniestrosAutos/Terceros';
  private readonly baseUrlComplemento = environment.wsUrl + 'api/SiniestrosAutos/Complemento';

  constructor(private http: HttpClient) { }

  consultaTipoTercero(input: ConsultaTipoTerceroInput): Observable<ResultApiResponse<ConsultaTipoTerceroOutput>> {
    return this.http.post<ResultApiResponse<ConsultaTipoTerceroOutput>>(`${this.baseUrl}/ConsultaTipoTercero`, input);
  }

  consultaCategorias(input: ConsultaCategoriasInput): Observable<ResultApiResponse<ConsultaCategoriasOutput>> {
    return this.http.post<ResultApiResponse<ConsultaCategoriasOutput>>(`${this.baseUrl}/ConsultaCategorias`, input);
  }

  consultaEstatus(input: ConsultaEstatusInput): Observable<ResultApiResponse<ConsultaEstatusOutput>> {
    return this.http.post<ResultApiResponse<ConsultaEstatusOutput>>(`${this.baseUrl}/ConsultaEstatus`, input);
  }

  consultaCompanias(input: ConsultaCompaniasInput): Observable<ResultApiResponse<ConsultaCompaniasOutput>> {
    return this.http.post<ResultApiResponse<ConsultaCompaniasOutput>>(`${this.baseUrl}/ConsultaCompanias`, input);
  }

  consultaTipoPersona(input: ConsultaTipoPersonaInput): Observable<ResultApiResponse<ConsultaTipoPersonaOutput>> {
    return this.http.post<ResultApiResponse<ConsultaTipoPersonaOutput>>(`${this.baseUrl}/ConsultaTipoPersona`, input);
  }

  consultaCoberturas(input: ConsultaCoberturasInput): Observable<ResultApiResponse<ConsultaCoberturasOutput>> {
    return this.http.post<ResultApiResponse<ConsultaCoberturasOutput>>(`${this.baseUrl}/ConsultaCoberturas`, input);
  }

  consultaColores(input: ConsultaColoresInput): Observable<ResultApiResponse<ConsultaColoresOutput>> {
    return this.http.post<ResultApiResponse<ConsultaColoresOutput>>(`${this.baseUrl}/ConsultaColores`, input);
  }

  consultaModelos(input: ConsultaModelosInput): Observable<ResultApiResponse<ConsultaModelosOutput>> {
    return this.http.post<ResultApiResponse<ConsultaModelosOutput>>(`${this.baseUrl}/ConsultaModelos`, input);
  }

  consultaMarcas(input: ConsultaMarcasInput): Observable<ResultApiResponse<ConsultaMarcasOutput>> {
    return this.http.post<ResultApiResponse<ConsultaMarcasOutput>>(`${this.baseUrl}/ConsultaMarcas`, input);
  }

  consultaSubTipos(input: ConsultaSubTiposInput): Observable<ResultApiResponse<ConsultaSubTiposOutput>> {
    return this.http.post<ResultApiResponse<ConsultaSubTiposOutput>>(`${this.baseUrl}/ConsultaSubTipos`, input);
  }

  consultaVehiculos(input: ConsultaVehiculosInput): Observable<ResultApiResponse<ConsultaVehiculosOutput>> {
    return this.http.post<ResultApiResponse<ConsultaVehiculosOutput>>(`${this.baseUrl}/ConsultaVehiculos`, input);
  }

  consultaTerceros(input: ConsultaTercerosInput): Observable<ResultApiResponse<ConsultaTercerosOutput>> {
    return this.http.post<ResultApiResponse<ConsultaTercerosOutput>>(`${this.baseUrl}/ConsultaTerceros`, input);
  }

  guardaActualizaTercero(input: GuardaActualizaTerceroInput): Observable<ResultApiResponse<GuardaActualizaTerceroOutput>> {
    return this.http.post<ResultApiResponse<GuardaActualizaTerceroOutput>>(`${this.baseUrl}/GuardaActualizaTercero`, input);
  }

  eliminaTercero(input: EliminaTerceroInput): Observable<ResultApiResponse<EliminaTerceroOutput>> {
    return this.http.post<ResultApiResponse<EliminaTerceroOutput>>(`${this.baseUrl}/EliminaTercero`, input);
  }

  //Complemento
  consultaOficinas(input: ConsultaOficinasInput): Observable<ResultApiResponse<ConsultaOficinasOutput>> {
    return this.http.post<ResultApiResponse<ConsultaOficinasOutput>>(`${this.baseUrlComplemento}/ConsultaOficinas`, input);
  }

  consultaOperadores(input: ConsultaOperadoresInput): Observable<ResultApiResponse<ConsultaOperadoresOutput>> {
    return this.http.post<ResultApiResponse<ConsultaOperadoresOutput>>(`${this.baseUrlComplemento}/ConsultaOperadores`, input);
  }

  consultaFechas(input: ConsultaFechasInput): Observable<ResultApiResponse<ConsultaFechasOutput>> {
    return this.http.post<ResultApiResponse<ConsultaFechasOutput>>(`${this.baseUrlComplemento}/ConsultaFechas`, input);
  }

  consultaCausas(input: ConsultaCausasInput): Observable<ResultApiResponse<ConsultaCausasOutput>> {
    return this.http.post<ResultApiResponse<ConsultaCausasOutput>>(`${this.baseUrlComplemento}/ConsultaCausas`, input);
  }

  consultaSubCausas(input: ConsultaSubCausasInput): Observable<ResultApiResponse<ConsultaSubCausasOutput>> {
    return this.http.post<ResultApiResponse<ConsultaSubCausasOutput>>(`${this.baseUrlComplemento}/ConsultaSubCausas`, input);
  }

  consultaSexo(input: ConsultaSexoInput): Observable<ResultApiResponse<ConsultaSexoOutput>> {
    return this.http.post<ResultApiResponse<ConsultaSexoOutput>>(`${this.baseUrlComplemento}/ConsultaSexo`, input);
  }

  consultaTipoPerdida(input: ConsultaTipoPerdidaInput): Observable<ResultApiResponse<ConsultaTipoPerdidaOutput>> {
    return this.http.post<ResultApiResponse<ConsultaTipoPerdidaOutput>>(`${this.baseUrlComplemento}/ConsultaTipoPerdida`, input);
  }

  consultaTipoEstimaciones(input: ConsultaTipoEstimacionesInput): Observable<ResultApiResponse<ConsultaTipoEstimacionesOutput>> {
    return this.http.post<ResultApiResponse<ConsultaTipoEstimacionesOutput>>(`${this.baseUrlComplemento}/ConsultaTipoEstimaciones`, input);
  }

  consultaTipoUbicaciones(input: ConsultaTipoUbicacionesInput): Observable<ResultApiResponse<ConsultaTipoUbicacionesOutput>> {
    return this.http.post<ResultApiResponse<ConsultaTipoUbicacionesOutput>>(`${this.baseUrlComplemento}/ConsultaTipoUbicaciones`, input);
  }

  consultaSubTipoUbicaciones(input: ConsultaSubTipoUbicacionesInput): Observable<ResultApiResponse<ConsultaSubTipoUbicacionesOutput>> {
    return this.http.post<ResultApiResponse<ConsultaSubTipoUbicacionesOutput>>(`${this.baseUrlComplemento}/ConsultaSubTipoUbicaciones`, input);
  }

  consultaTipoSiniestro(input: ConsultaTipoSiniestroInput): Observable<ResultApiResponse<ConsultaTipoSiniestroOutput>> {
    return this.http.post<ResultApiResponse<ConsultaTipoSiniestroOutput>>(`${this.baseUrlComplemento}/ConsultaTipoSiniestro`, input);
  }

  consultaPaises(input: ConsultaPaisesInput): Observable<ResultApiResponse<ConsultaPaisesOutput>> {
    return this.http.post<ResultApiResponse<ConsultaPaisesOutput>>(`${this.baseUrlComplemento}/ConsultaPaises`, input);
  }

  consultaEstados(input: ConsultaEstadosInput): Observable<ResultApiResponse<ConsultaEstadosOutput>> {
    return this.http.post<ResultApiResponse<ConsultaEstadosOutput>>(`${this.baseUrlComplemento}/ConsultaEstados`, input);
  }

  consultaMunicipios(input: ConsultaMunicipiosInput): Observable<ResultApiResponse<ConsultaMunicipiosOutput>> {
    return this.http.post<ResultApiResponse<ConsultaMunicipiosOutput>>(`${this.baseUrlComplemento}/ConsultaMunicipios`, input);
  }

  consultaTiposRobo(input: ConsultaTiposRoboInput): Observable<ResultApiResponse<ConsultaTiposRoboOutput>> {
    return this.http.post<ResultApiResponse<ConsultaTiposRoboOutput>>(`${this.baseUrlComplemento}/ConsultaTiposRobo`, input);
  }

  consultaEstatusLesionado(input: ConsultaEstatusLesionadoInput): Observable<ResultApiResponse<ConsultaEstatusLesionadoOutput>> {
    return this.http.post<ResultApiResponse<ConsultaEstatusLesionadoOutput>>(`${this.baseUrlComplemento}/ConsultaEstatusLesionado`, input);
  }

  consultaProveedor(input: ConsultaProveedorInput): Observable<ResultApiResponse<ConsultaProveedorOutput>> {
    return this.http.post<ResultApiResponse<ConsultaProveedorOutput>>(`${this.baseUrlComplemento}/ConsultaProveedor`, input);
  }

  consultaTiposPagos(input: ConsultaTiposPagosInput): Observable<ResultApiResponse<ConsultaTiposPagosOutput>> {
    return this.http.post<ResultApiResponse<ConsultaTiposPagosOutput>>(`${this.baseUrlComplemento}/ConsultaTiposPagos`, input);
  }

  consultaSubTiposPagos(input: ConsultaSubTiposPagosInput): Observable<ResultApiResponse<ConsultaSubTiposPagosOutput>> {
    return this.http.post<ResultApiResponse<ConsultaSubTiposPagosOutput>>(`${this.baseUrlComplemento}/ConsultaSubTiposPagos`, input);
  }

  consultaCoberturasXTipoySubtipoPagos(input: ConsultaCoberturasXTipoySubtipoPagosInput): Observable<ResultApiResponse<ConsultaCoberturasXTipoySubtipoPagosOutput>> {
    return this.http.post<ResultApiResponse<ConsultaCoberturasXTipoySubtipoPagosOutput>>(`${this.baseUrlComplemento}/ConsultaCoberturasXTipoySubtipoPagos`, input);
  }

  consultaImporteSipac(input: ConsultaImporteSipacInput): Observable<ResultApiResponse<ConsultaImporteSipacOutput>> {
    return this.http.post<ResultApiResponse<ConsultaImporteSipacOutput>>(`${this.baseUrlComplemento}/ConsultaImporteSipac`, input);
  }

  consultaTradicionalTipo(input: ConsultaTradicionalTipoInput): Observable<ResultApiResponse<ConsultaTradicionalTipoOutput>> {
    return this.http.post<ResultApiResponse<ConsultaTradicionalTipoOutput>>(`${this.baseUrlComplemento}/ConsultaTradicionalTipo`, input);
  }

  consultaTipoServicios(input: ConsultaTipoServiciosInput): Observable<ResultApiResponse<ConsultaTipoServiciosOutput>> {
    return this.http.post<ResultApiResponse<ConsultaTipoServiciosOutput>>(`${this.baseUrlComplemento}/ConsultaTipoServicios`, input);
  }

  consultaTipoGrua(input: ConsultaTipoGruaInput): Observable<ResultApiResponse<ConsultaTipoGruaOutput>> {
    return this.http.post<ResultApiResponse<ConsultaTipoGruaOutput>>(`${this.baseUrlComplemento}/ConsultaTipoGrua`, input);
  }

  consultaEventoServicio(input: ConsultaEventoServicioInput): Observable<ResultApiResponse<ConsultaEventoServicioOutput>> {
    return this.http.post<ResultApiResponse<ConsultaEventoServicioOutput>>(`${this.baseUrlComplemento}/ConsultaEventoServicio`, input);
  }

  consultaEstatusConcepto(input: ConsultaEstatusConceptoInput): Observable<ResultApiResponse<ConsultaEstatusConceptoOutput>> {
    return this.http.post<ResultApiResponse<ConsultaEstatusConceptoOutput>>(`${this.baseUrlComplemento}/ConsultaEstatusConcepto`, input);
  }

  consultaEstatusAbogado(input: ConsultaEstatusAbogadoInput): Observable<ResultApiResponse<ConsultaEstatusAbogadoOutput>> {
    return this.http.post<ResultApiResponse<ConsultaEstatusAbogadoOutput>>(`${this.baseUrlComplemento}/ConsultaEstatusAbogado`, input);
  }

  consultaTipoPase(input: ConsultaTipoPaseInput): Observable<ResultApiResponse<ConsultaTipoPaseOutput>> {
    return this.http.post<ResultApiResponse<ConsultaTipoPaseOutput>>(`${this.baseUrlComplemento}/ConsultaTipoPase`, input);
  }


  consultaAjustadores(input: ConsultaAjustadoresInput): Observable<ResultApiResponse<ConsultaAjustadoresOutput>> {
    return this.http.post<ResultApiResponse<ConsultaAjustadoresOutput>>(`${this.baseUrlComplemento}/ConsultaAjustadores`, input);
  }

  consultaDireccion(input: ConsultaDireccionInput): Observable<ResultApiResponse<ConsultaDireccionOutput>> {
    return this.http.post<ResultApiResponse<ConsultaDireccionOutput>>(`${this.baseUrlComplemento}/ConsultaDireccion`, input);
  }

  consultaSiniestros(input: ConsultaSiniestrosInput): Observable<ResultApiResponse<ConsultaSiniestrosOutput>> {
    return this.http.post<ResultApiResponse<ConsultaSiniestrosOutput>>(`${this.baseUrlComplemento}/ConsultaSiniestros`, input);
  }

  consultaSiniestro(input: ConsultaSiniestroInput): Observable<ResultApiResponse<ConsultaSiniestroOutput>> {
    return this.http.post<ResultApiResponse<ConsultaSiniestroOutput>>(`${this.baseUrlComplemento}/ConsultaSiniestro`, input);
  }

  consultaConvenios(input: ConsultaConveniosInput): Observable<ResultApiResponse<ConsultaConveniosOutput>> {
    return this.http.post<ResultApiResponse<ConsultaConveniosOutput>>(`${this.baseUrlComplemento}/ConsultaConvenios`, input);
  }

  consultaComplementoGeneral(input: ConsultaComplementoGeneralInput): Observable<ResultApiResponse<ConsultaComplementoGeneralOutput>> {
    return this.http.post<ResultApiResponse<ConsultaComplementoGeneralOutput>>(`${this.baseUrlComplemento}/ConsultaComplementoGeneral`, input);
  }

  actualizaComplemento(input: ActualizaComplementoInput): Observable<ResultApiResponse<ActualizaComplementoOutput>> {
    return this.http.post<ResultApiResponse<ActualizaComplementoOutput>>(`${this.baseUrlComplemento}/ActualizaComplemento`, input);
  }

  consultaServiciosGeneral(input: ConsultaServiciosGeneralInput): Observable<ResultApiResponse<ConsultaServiciosGeneralOutput>> {
    return this.http.post<ResultApiResponse<ConsultaServiciosGeneralOutput>>(`${this.baseUrlComplemento}/ConsultaServiciosGeneral`, input);
  }

  consultaServicios(input: ConsultaServiciosInput): Observable<ResultApiResponse<ConsultaServiciosOutput>> {
    return this.http.post<ResultApiResponse<ConsultaServiciosOutput>>(`${this.baseUrlComplemento}/ConsultaServicios`, input);
  }

  actualizaServicio(input: ActualizaServicioInput): Observable<ResultApiResponse<ActualizaServicioOutput>> {
    return this.http.post<ResultApiResponse<ActualizaServicioOutput>>(`${this.baseUrlComplemento}/ActualizaServicio`, input);
  }

  consultaLesionadosGeneral(input: ConsultaLesionadosGeneralInput): Observable<ResultApiResponse<ConsultaLesionadosGeneralOutput>> {
    return this.http.post<ResultApiResponse<ConsultaLesionadosGeneralOutput>>(`${this.baseUrlComplemento}/ConsultaLesionadosGeneral`, input);
  }

  consultaLesionados(input: ConsultaLesionadosInput): Observable<ResultApiResponse<ConsultaLesionadosOutput>> {
    return this.http.post<ResultApiResponse<ConsultaLesionadosOutput>>(`${this.baseUrlComplemento}/ConsultaLesionados`, input);
  }

  guardaActualizaLesionado(input: GuardaActualizaLesionadoInput): Observable<ResultApiResponse<GuardaActualizaLesionadoOutput>> {
    return this.http.post<ResultApiResponse<GuardaActualizaLesionadoOutput>>(`${this.baseUrlComplemento}/GuardaActualizaLesionado`, input);
  }

  eliminaLesionado(input: EliminaLesionadoInput): Observable<ResultApiResponse<EliminaLesionadoOutput>> {
    return this.http.post<ResultApiResponse<EliminaLesionadoOutput>>(`${this.baseUrlComplemento}/EliminaLesionado`, input);
  }

  consultaLesionadosServicios(input: ConsultaLesionadosServiciosInput): Observable<ResultApiResponse<ConsultaLesionadosServiciosOutput>> {
    return this.http.post<ResultApiResponse<ConsultaLesionadosServiciosOutput>>(`${this.baseUrlComplemento}/ConsultaLesionadosServicios`, input);
  }

  consultaRecuperacionesPagos(input: ConsultaRecuperacionesPagosInput): Observable<ResultApiResponse<ConsultaRecuperacionesPagosOutput>> {
    return this.http.post<ResultApiResponse<ConsultaRecuperacionesPagosOutput>>(`${this.baseUrlComplemento}/ConsultaRecuperacionesPagos`, input);
  }

  consultaRecuperacionesPagosReferencias(input: ConsultaRecuperacionesPagosReferenciasInput): Observable<ResultApiResponse<ConsultaRecuperacionesPagosReferenciasOutput>> {
    return this.http.post<ResultApiResponse<ConsultaRecuperacionesPagosReferenciasOutput>>(`${this.baseUrlComplemento}/ConsultaRecuperacionesPagosReferencias`, input);
  }

  guardaActualizaRecuperacionPago(input: GuardaActualizaRecuperacionPagoInput): Observable<ResultApiResponse<GuardaActualizaRecuperacionPagoOutput>> {
    return this.http.post<ResultApiResponse<GuardaActualizaRecuperacionPagoOutput>>(`${this.baseUrlComplemento}/GuardaActualizaRecuperacionPago`, input);
  }

  eliminaRecuperacionPago(input: EliminaRecuperacionPagoInput): Observable<ResultApiResponse<EliminaRecuperacionPagoOutput>> {
    return this.http.post<ResultApiResponse<EliminaRecuperacionPagoOutput>>(`${this.baseUrlComplemento}/EliminaRecuperacionPago`, input);
  }

  consultaEstimaciones(input: ConsultaEstimacionesInput): Observable<ResultApiResponse<ConsultaEstimacionesOutput>> {
    return this.http.post<ResultApiResponse<ConsultaEstimacionesOutput>>(`${this.baseUrlComplemento}/ConsultaEstimaciones`, input);
  }

  guardaEstimacion(input: GuardaEstimacionInput): Observable<ResultApiResponse<GuardaEstimacionOutput>> {
    return this.http.post<ResultApiResponse<GuardaEstimacionOutput>>(`${this.baseUrlComplemento}/GuardaEstimacion`, input);
  }

  consultaConceptosXtenders(input: ConsultaConceptosXtendersInput): Observable<ResultApiResponse<ConsultaConceptosXtendersOutput>> {
    return this.http.post<ResultApiResponse<ConsultaConceptosXtendersOutput>>(`${this.baseUrlComplemento}/ConsultaConceptosXtenders`, input);
  }

  consultaFotografias(input: ConsultaFotografiasInput): Observable<ResultApiResponse<ConsultaFotografiasOutput>> {
    return this.http.post<ResultApiResponse<ConsultaFotografiasOutput>>(`${this.baseUrlComplemento}/ConsultaFotografias`, input);
  }

  guardaFotografias(input: GuardaFotografiasInput): Observable<ResultApiResponse<GuardaFotografiasOutput>> {
    return this.http.post<ResultApiResponse<GuardaFotografiasOutput>>(`${this.baseUrlComplemento}/GuardaFotografias`, input);
  }

  eliminaFotografia(input: EliminaFotografiaInput): Observable<ResultApiResponse<EliminaFotografiaOutput>> {
    return this.http.post<ResultApiResponse<EliminaFotografiaOutput>>(`${this.baseUrlComplemento}/EliminaFotografia`, input);
  }

  generaExpedienteElectronico(input: GeneraExpedienteElectronicoInput): Observable<ResultApiResponse<GeneraExpedienteElectronicoOutput>> {
    return this.http.post<ResultApiResponse<GeneraExpedienteElectronicoOutput>>(`${this.baseUrlComplemento}/GeneraExpedienteElectronico`, input);
  }

  cancelarSubirArchivosExtender(input: CancelarSubirArchivosExtenderInput): Observable<ResultApiResponse<CancelarSubirArchivosExtenderOutput>> {
    return this.http.post<ResultApiResponse<CancelarSubirArchivosExtenderOutput>>(`${this.baseUrlComplemento}/CancelarSubirArchivosExtender`, input);
  }

  consultaReglasAjuste(input: ConsultaReglasAjusteInput): Observable<ResultApiResponse<ConsultaReglasAjusteOutput>> {
    return this.http.post<ResultApiResponse<ConsultaReglasAjusteOutput>>(`${this.baseUrlComplemento}/ConsultaReglasAjuste`, input);
  }

  actualizaReglasAjuste(input: ActualizaReglasAjusteInput): Observable<ResultApiResponse<ActualizaReglasAjusteOutput>> {
    return this.http.post<ResultApiResponse<ActualizaReglasAjusteOutput>>(`${this.baseUrlComplemento}/ActualizaReglasAjuste`, input);
  }

  consultaResumenSiniestro(input: ConsultaResumenSiniestroInput): Observable<ResultApiResponse<ConsultaResumenSiniestroOutput>> {
    return this.http.post<ResultApiResponse<ConsultaResumenSiniestroOutput>>(`${this.baseUrlComplemento}/ConsultaResumenSiniestro`, input);
  }

  consultaSinCosto(input: ConsultaSinCostoInput): Observable<ResultApiResponse<ConsultaSinCostoOutput>> {
    return this.http.post<ResultApiResponse<ConsultaSinCostoOutput>>(`${this.baseUrlComplemento}/ConsultaSinCosto`, input);
  }

  verificaTerminoSiniestro(input: VerificaTerminoSiniestroInput): Observable<ResultApiResponse<VerificaTerminoSiniestroOutput>> {
    return this.http.post<ResultApiResponse<VerificaTerminoSiniestroOutput>>(`${this.baseUrlComplemento}/VerificaTerminoSiniestro`, input);
  }

  registraUsuarioPortal(input: RegistraUsuarioPortalInput): Observable<ResultApiResponse<RegistraUsuarioPortalOutput>> {
    return this.http.post<ResultApiResponse<RegistraUsuarioPortalOutput>>(`${this.baseUrlComplemento}/RegistraUsuarioPortal`, input);
  }

  actualizaTerminoSiniestro(input: ActualizaTerminoSiniestroInput): Observable<ResultApiResponse<ActualizaTerminoSiniestroOutput>> {
    return this.http.post<ResultApiResponse<ActualizaTerminoSiniestroOutput>>(`${this.baseUrlComplemento}/ActualizaTerminoSiniestro`, input);
  }

  guardaActualizaObservaciones(input: GuardaActualizaObservacionesInput): Observable<ResultApiResponse<GuardaActualizaObservacionesOutput>> {
    return this.http.post<ResultApiResponse<GuardaActualizaObservacionesOutput>>(`${this.baseUrlComplemento}/GuardaActualizaObservaciones`, input);
  }

  consultaContadores(input: ConsultaContadoresInput): Observable<ResultApiResponse<ConsultaContadoresOutput>> {
    return this.http.post<ResultApiResponse<ConsultaContadoresOutput>>(`${this.baseUrlComplemento}/ConsultaContadores`, input);
  }

  logOut(input: LogOutInput): Observable<ResultApiResponse<LogOutOutput>> {
    return this.http.post<ResultApiResponse<LogOutOutput>>(`${this.baseUrlComplemento}/LogOut`, input);
  }

  validaCoberturasServicioTaller(input: ValidaCoberturasServicioTallerInput): Observable<ResultApiResponse<ValidaCoberturasServicioTallerOutput>> {
    return this.http.post<ResultApiResponse<ValidaCoberturasServicioTallerOutput>>(`${this.baseUrlComplemento}/ValidaCoberturasServicioTaller`, input);
  }
}
